// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"campaign___wrapper___1ytTi"};